let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iw8Ph")).then(() => parcelRequire('hh8BY'));